export const MENU_ITEMS = [
    {
      label: "Home",
      staticLink: true,
      path: "/",
      offset: "70",
    },
    {
      label: "Pricing",
      staticLink: false,
      path: "#pricing",
      offset: "70",
    },
    {
      label: "Sign In",
      staticLink: true,
      path: "/signin",
      offset: "70",
    },
  ];

  export const TOP_MENU_ITEMS = [
    {
      label: "Home",
      staticLink: true,
      path: "/",
      offset: "70",
    },    
    {
      label: "AI Cover Letter",
      staticLink: true,
      path: "/ai-cover-letter",
      offset: "70",
    },   
    {
      label: "AI Resume",
      staticLink: true,
      path: "/ai-resume",
      offset: "70",
    },   
    {
      label: "Auto-Apply",
      staticLink: true,
      path: "/ai-auto-apply",
      offset: "70",
    },
    {
      label: "About Us",
      staticLink: true,
      path: "/about",
      offset: "70",
    },             
    {
      label: "Pricing",
      staticLink: false,
      basePath: "/",
      scrollPath: "#pricing",
      path: "../#pricing",
      offset: "70",
    },
    {
      label: "Resources",
      staticLink: true,
      path: "/resources",
      offset: "70",
    },    
    {
      label: "Help Center",
      staticLink: true,
      path: "/help",
      offset: "70",
    },        
    {
      label: "Sign In",
      staticLink: true,
      path: "/signin",
      offset: "70",
    },
    {
      label: "Sign Up",
      staticLink: true,
      path: "/signup",
      offset: "70",
    },
  ];

  export const MOBILE_MENU_ITEMS = [
    {
      label: "Home",
      staticLink: true,
      path: "/",
      offset: "70",
    },    
    {
      label: "About Us",
      staticLink: true,
      path: "/about",
      offset: "70",
    },    
    {
      label: "Auto-Apply",
      staticLink: true,
      path: "/ai-auto-apply",
      offset: "70",
    },        
    {
      label: "AI Cover Letter",
      staticLink: true,
      path: "/ai-cover-letter",
      offset: "70",
    },
    {
      label: "AI Resume",
      staticLink: true,
      path: "/ai-resume",
      offset: "70",
    },
    {
      label: "Pricing",
      staticLink: false,
      basePath: "/",
      scrollPath: "#pricing",
      path: "../#pricing",
      offset: "70",
    },
    {
      label: "Resources",
      staticLink: true,
      path: "/resources",
      offset: "70",
    },    
    {
      label: "Help Center",
      staticLink: true,
      path: "/help",
      offset: "70",
    },        
    {
      label: "Sign In",
      staticLink: true,
      path: "/signin",
      offset: "70",
    },
    {
      label: "Sign Up",
      staticLink: true,
      path: "/signup",
      offset: "70",
    },
  ];
